import React from 'react';
import Configurator from './Configurator.jsx';
import styles from './GroundCalculationConfigurator.styl';
import Image from './ui/features/Image.jsx';
import Button from './ui/button/Button.jsx'
import DropDown from './ui/features/DropDown/DropDown.jsx'
import Input from './ui/features/Input/Input.jsx'
import {PDFDownloadLink} from '@react-pdf/renderer'
import PDFCountReport from './ui/PDFCreation/PDFGrondCountReport'
import Popup from './ui/features/Popup/Popup.jsx'
import TextAreaInput from './ui/features/TextArea/TextAreaInput.jsx'
import ImageInput from './ui/features/ImageInput/ImageInput.jsx'
import GroundLightVersion from './ui/features/Version/GroundLightVersion.jsx'

const defaultState = {
	filterRn:'',
	filterClimate:'I',
	filterRo1:'',
	filterRo2:'',
	filterH:'',
	filterLv:3,
	filterDv:'16',
	filterPosition:'В ряд',
	filterRatio:1,
	filterSg:'40x4',
	filterLCon:2,
	filterT:0.7,
	reportEnable:false,
	kc1:0,
	kc2:0,
	ki1:0,
	ki2:0,
	npred:0,
}

const ksTable = {
	ks1:{
		I:2,
		II:1.7,
		III:1.4,
		IV:1.2,
	},
	ks2:{
		I:7,
		II:4,
		III:2,
		IV:1.5,
	}
}

const ki1Table = {
	'В ряд':{
		1:{
			2:0.85,
			4:0.73,
			6:0.65,
			10:0.59,
			20:0.48,
		},
		2:{
			2:0.91,
			4:0.83,
			6:0.77,
			10:0.74,
			20:0.67,
		},
		3:{
			2:0.94,
			4:0.89,
			6:0.85,
			10:0.81,
			20:0.76,
		},
	},
	'По контуру':{
		1:{
			4:0.69,
			6:0.61,
			10:0.56,
			20:0.47,
			40:0.41,
			60:0.39,
			100:0.36,
		},
		2:{
			4:0.78,
			6:0.73,
			10:0.68,
			20:0.63,
			40:0.58,
			60:0.55,
			100:0.52,
		},
		3:{
			4:0.85,
			6:0.8,
			10:0.76,
			20:0.71,
			40:0.66,
			60:0.64,
			100:0.62,
		},
	}
}

const ki2Table = {
	'В ряд':{
		1:{
			2:0.85,
			4:0.66,
			6:0.72,
			10:0.62,
			20:0.42,
		},
		2:{
			2:0.94,
			4:0.8,
			6:0.84,
			10:0.75,
			20:0.56,
		},
		3:{
			2:0.96,
			4:0.92,
			6:0.88,
			10:0.82,
			20:0.68,
		},
	},
	'По контуру':{
		1:{
			4:0.45,
			6:0.4,
			10:0.34,
			20:0.27,
			40:0.22,
			60:0.2,
			100:0.19,
		},
		2:{
			4:0.55,
			6:0.48,
			10:0.4,
			20:0.32,
			40:0.29,
			60:0.27,
			100:0.23,
		},
		3:{
			4:0.7,
			6:0.64,
			10:0.56,
			20:0.45,
			40:0.39,
			60:0.36,
			100:0.33,
		},
	}
}

const defaultResult = {
	pekv:0,
	roc:0,
	rv:0,
	rline:0,
	r:0,
	lp:0,
	lv:0,
	n:0,
	t:0
}

class GroundCalculationConfigurator extends Configurator {

	constructor(props) {
		super(props);
		this.state = {

			filterName: '',
			filterAuthor: '',
			filterAddress: '',
			filterDesc: '',
			filterProjectImg: '',

			climateOptions:['I', 'II', 'III', 'IV'],
			dvOptions:['14', '16', '18', '20'],
			positionOptions:['В ряд', 'По контуру'],
			sgOptions:['40x4', '50x4', '50x5', '25x4'],

			showAdditionlConInfo: false,
			showAdditionRnInfo: false,

			warningText:'',

			showWarn:false,

			...defaultState,
			...defaultResult
		}

		// Отрисовка
		this.getResultStr	 						= this.getResultStr.bind(this);
		this.getCountBlock 						= this.getCountBlock.bind(this);
		this.getRnSection 						= this.getRnSection.bind(this);
		this.getGroundSection 				= this.getGroundSection.bind(this);
		this.getVerticalSection 			= this.getVerticalSection.bind(this);
		this.getHorizontalSection 		= this.getHorizontalSection.bind(this);
		this.infoInput 								= this.infoInput.bind(this);

		// Служебные процедуры и функции
		this.getFilterFromType 				= this.getFilterFromType.bind(this);
		this.getOptionsFromType 			= this.getOptionsFromType.bind(this);
		this.getChangeFromType 				= this.getChangeFromType.bind(this);
		this.getBlurFromType 					= this.getBlurFromType.bind(this);
		this.getDisablesState 				= this.getDisablesState.bind(this);
		this.showWarning 							= this.showWarning.bind(this);
		this.closeWarning 						= this.closeWarning.bind(this);
		this.clickAwayHandler 				= this.clickAwayHandler.bind(this);
		this.getCoef					 				= this.getCoef.bind(this);

		// Обработка событий
		this.onRnChange 							= this.onRnChange.bind(this);
		this.onRnBlur 								= this.onRnBlur.bind(this);
		this.onClimateChange 					= this.onClimateChange.bind(this);
		this.onRo1Change 							= this.onRo1Change.bind(this);
		this.onRo1Blur 								= this.onRo1Blur.bind(this);
		this.onRo2Change 							= this.onRo2Change.bind(this);
		this.onRo2Blur 								= this.onRo2Blur.bind(this);
		this.onHChange 								= this.onHChange.bind(this);
		this.onHBlur 									= this.onHBlur.bind(this);
		this.onLvChange 							= this.onLvChange.bind(this);
		this.onLvBlur									= this.onLvBlur.bind(this);
		this.onDvChange 							= this.onDvChange.bind(this);
		this.onPositionChange 				= this.onPositionChange.bind(this);
		this.onRatioChange 						= this.onRatioChange.bind(this);
		this.onRatioBlur 							= this.onRatioBlur.bind(this);
		this.onSgChange 							= this.onSgChange.bind(this);
		this.onLConChange 						= this.onLConChange.bind(this);
		this.onLConBlur 							= this.onLConBlur.bind(this);
		this.onTChange 								= this.onTChange.bind(this);
		this.onTBlur 									= this.onTBlur.bind(this);

		//Кнопки
		this.onBtnCountClick 					= this.onBtnCountClick.bind(this);
		this.onBtnClearClick 					= this.onBtnClearClick.bind(this);
		this.onBtnSaveClick 					= this.onBtnSaveClick.bind(this);

		this.onNameChange = this.onNameChange.bind(this);
		this.onAuthorChange = this.onAuthorChange.bind(this);
		this.onAddressChange = this.onAddressChange.bind(this);
		this.onDescChange = this.onDescChange.bind(this);
		this.onProjectImgChange = this.onProjectImgChange.bind(this);

		this.onNavConfigurator = this.onNavConfigurator.bind(this)
		this.onDocConfigurator = this.onDocConfigurator.bind(this)

	}

	componentDidMount(){
		this.closeWarning()
	}

	// ++ Для Запуска
	getCustomStyles() {
		return styles;
	}
	getType() {
		return 'ground_calc';
	}
	// -- Для Запуска


// ++ Служебные процедуры и функции
	getFilterFromType(type) {
		return 'filter' + this.capitalizeFirstLetter(type)
	}

	getOptionsFromType(type) {
		return type + 'Options'
	}

	getChangeFromType(type) {
		return 'on' + this.capitalizeFirstLetter(type) + 'Change'
	}

	getBlurFromType(type){
		return 'on' + this.capitalizeFirstLetter(type) + 'Blur'
	}

	getDisablesState(type) {
		return type + 'Disabled'
	}

	showWarning(warningText){
		this.setState({
			warningText,
			showWarn: true,
		})
	}

	clickAwayHandler(event){
			this.closeWarning()
	}

	getCoef(number, obj){

		let arr = []
		let result = 0
		for (let key in obj){
			if(Number(key) === number){
				return result = obj[key]
			}
			arr.push({key:Number(key), value:obj[key]})
		}
		if(result) return result

		let min = Math.min.apply(null, arr.map(item => item.key))
		let max = Math.max.apply(null, arr.map(item => item.key))
		if(number<min){
			return obj[min]
		}else if(number > min && number < max){
			let coef = 0
			arr.map((item,idx) =>{
				if(number > item.key && number < arr[idx+1].key){
					let prosent = (number-item.key) * 100 / (arr[idx+1].key-item.key)
					coef = Math.abs(prosent * (arr[idx].value-item.value)/100) + item.value
				}
			})
			return coef
		}else if(number > max){
			return obj[max]
		}
	}

	closeWarning(){
		this.setState({showWarn: false})
	}

// -- Служебные процедуры и функции

// ++ Рендер
	getResultStr(props){
		const {top, str, result} = props

		return (<div className={styles.smallText}
									 style={{
										 position: 'absolute',
										 top:`${top}px`,
										 left:'220px',
									 }}
								 key = {'result' + top}>

			<span
				style={{
					marginRight: '10px'
				}}
			>{str}</span>
			{result ?
				<span
					style={{
						fontWeight: 'bold'
					}}>{result}</span> :
				null
			}

		</div>)

	}

	getCountBlock(){
		let elements = [];

		elements.push(...this.getRnSection())
		elements.push(...this.getGroundSection())
		elements.push(...this.getVerticalSection())
		elements.push(...this.getHorizontalSection())

		return elements;
	}

	getRnSection(){
		let elements = [];

		elements.push(<div
			key={'rn' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'55px',
				left:'20px',
				width:'460px',
				zIndex:'10'
			}}
		>Нормируемое сопротивление заземляющего устройства растеканию тока Rн,  Ом:</div>)

		elements.push(<Input
			x={490}
			y={50}
			labelWidth={480}
			width={80}
			// title='Нормируемое сопротивление заземляющего устройства растеканию тока Rн,  Ом:'
			type = 'number'
			min={0}
			step={1}
			key={'rn' + elements.length}
			onChange={this[this.getChangeFromType('rn')]}
			onBlur={this[this.getBlurFromType('rn')]}
			value={this.state[this.getFilterFromType('rn')]}
		/>)


		elements.push(<div key={'rn' + elements.length}>
		<span className={styles.rnInfo}
					onPointerEnter={() => this.setState({showAdditionRnInfo: true})}
					onPointerLeave={() => this.setState({showAdditionRnInfo: false})}>&#63;</span>
			{this.state.showAdditionRnInfo
				&& <span className={styles.showRnCon}>
						Значение Rn необходимо вззять из ПУЭ: "1.7.101. Сопротивление заземляющего устройства, к которому присоединены нейтрали
генератора или трансформатора или выводы источника однофазного тока, в любое время
года должно быть не более 2, 4 и 8 Ом соответственно при линейных напряжениях 660, 380 и
220 В источника трехфазного тока или 380, 220 и 127 В источника однофазного тока. Это
сопротивление должно быть обеспечено с учетом использования естественных заземлителей,
а также заземлителей повторных заземлений PEN- или РЕ-проводника ВЛ напряжением до 1
кВ при количестве отходящих линий не менее двух. Сопротивление заземлителя,
расположенного в непосредственной близости от нейтрали генератора или трансформатора
или вывода источника однофазного тока, должно быть не более 15, 30 и 60 Ом
соответственно при линейных напряжениях 660, 380 и 220 В источника трехфазного тока
или 380, 220 и 127 В источника однофазного тока.
При удельном сопротивлении земли ρ >100 Ом⋅м допускается увеличивать указанные
нормы в 0,01ρ раз, но не более десятикратного."</span>}
		</div>)

		elements.push(<div
			key={'rn' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'55px',
				left:'650px',
				width:'120px',
				zIndex:'10'
			}}
		>Климатическая зона:</div>)

		elements.push(<DropDown
			x={785}
			y={50}
			width={80}
			key={'rn' + elements.length}
			onChange={this[this.getChangeFromType('climate')]}
			value={this.state[this.getFilterFromType('climate' )]}
			options={this.state[this.getOptionsFromType('climate')]}
		/>)

		return elements;
	}

	getGroundSection(){
		let elements = [];

		elements.push(<div
			key={'ground' + elements.length}
			className={styles.sectionTitle} style={{
			position: 'absolute',
			margin: '0 auto',
			top:'90px',
			textAlign: 'center',
			width: '1040px',
		}}>
						<span style ={{
							minWidth:'500px',
						}}>
							Параметры грунта
						</span>
		</div>)

		elements.push(<div
			key={'ground' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'125px',
				left:'20px',
				zIndex:'10'
			}}
		>Удельное R верхнего слоя грунта p1, Ом*м:</div>)

		elements.push(<Input
			x={285}
			y={121}
			width={80}
			// title='Удельное R верхнего слоя грунта:'
			type = 'number'
			min={0}
			step={1}
			key={'ground' + elements.length}
			onChange={this[this.getChangeFromType('ro1')]}
			value={this.state[this.getFilterFromType('ro1')]}
			onBlur={this[this.getBlurFromType('ro1')]}
		/>)


		elements.push(<div
			key={'ground' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'165px',
				left:'20px',
				zIndex:'10'
			}}
		>Удельное R нижнего слоя грунта p2, Ом*м:</div>)

		elements.push(<Input
			x={285}
			y={161}
			width={80}
			// title='Удельное R нижнего слоя грунта:'
			type = 'number'
			min={0}
			step={1}
			key={'ground' + elements.length}
			onChange={this[this.getChangeFromType('ro2')]}
			value={this.state[this.getFilterFromType('ro2')]}
			onBlur={this[this.getBlurFromType('ro2')]}
		/>)

		elements.push(<div
			key={'ground' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'125px',
				left:'420px',
				zIndex:'10'
			}}
		>Толщина верхнего слоя грунта H, м:</div>)

		elements.push(<Input
			x={642}
			y={121}
			labelWidth={120}
			width={80}
			// title='Толщина верхнего слоя грунта H, м:'
			type = 'number'
			min={0}
			max={999}
			step={0.01}
			key={'ground' + elements.length}
			onChange={this[this.getChangeFromType('H')]}
			onBlur={this[this.getBlurFromType('H')]}
			value={this.state[this.getFilterFromType('H')]}
		/>)

		return elements;
	}

	getVerticalSection(){
		let elements = [];

		elements.push(<div
			key={'vertical' + elements.length}
			className={styles.sectionTitle} style={{
			position: 'absolute',
			margin: '0 auto',
			top:'190px',
			textAlign: 'center',
			width: '1040px',
		}}>
						<span style ={{
							minWidth:'500px',
						}}>
							Вертикальный заземлитель
						</span>
		</div>)

		elements.push(<div
			key={'vertical' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'223px',
				left:'20px',
				zIndex:'10'
			}}
		>Длина L, м:</div>)

		elements.push(<Input
			x={105}
			y={220}
			labelWidth={120}
			width={80}
			// title='Длина одного заземлителя, м'
			type = 'number'
			min={3}
			max={999}
			step={1.5}
			key={'vertical' + elements.length}
			onChange={this[this.getChangeFromType('lv')]}
			value={this.state[this.getFilterFromType('lv')]}
			onBlur={this[this.getBlurFromType('lv')]}
		/>)

		elements.push(<div
			key={'vertical' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'223px',
				left:'240px',
				zIndex:'10',
			}}
		>Диаметр d, мм:</div>)

		elements.push(<DropDown
			x={345}
			y={220}
			width={80}
			// title='Диаметр, мм:'
			key={'vertical' + elements.length}
			onChange={this[this.getChangeFromType('dv')]}
			value={this.state[this.getFilterFromType('dv')]}
			options={this.state[this.getOptionsFromType('dv')]}
		/>)

		elements.push(<div
			key={'vertical' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'223px',
				left:'480px',
				zIndex:'10'
			}}
		>Расположение:</div>)

		elements.push(<DropDown
			x={585}
			y={220}
			labelWidth={120}
			width={80}
			// title='Расположение заземлителей:'
			key={'vertical' + elements.length}
			onChange={this[this.getChangeFromType('position')]}
			value={this.state[this.getFilterFromType('position')]}
			options={this.state[this.getOptionsFromType('position')]}
		/>)

		elements.push(<div
			key={'vertical' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'217px',
				left:'720px',
				zIndex:'10',
				width:'175px'
			}}
		>Отношение расстояния между заземлителями к их длине С/L:</div>)

		elements.push(<Input
			x={910}
			y={220}
			width={80}
			// title='Отношение расстояний между вертикальными электродами к их длине:'
			type = 'number'
			min={1}
			max={3}
			step={1}
			key={'vertical' + elements.length}
			onChange={this[this.getChangeFromType('ratio')]}
			value={this.state[this.getFilterFromType('ratio')]}
			onBlur={this[this.getBlurFromType('ratio')]}
		/>)

		return elements;
	}

	getHorizontalSection(){
		let elements = []

		elements.push(<div
			key={'horizontal' + elements.length}
			className={styles.sectionTitle} style={{
			position: 'absolute',
			margin: '0 auto',
			top:'265px',
			textAlign: 'center',
			width: '1040px',
		}}>
						<span style ={{
							minWidth:'500px',
						}}>
							Горизонтальный заземлитель
						</span>
		</div>)

		elements.push(<div
			key={'horizontal' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'304px',
				left:'20px',
				zIndex:'10',
			}}
		>Глубина заложения от поверхности tполосы, м:</div>)

		elements.push(<Input
			x={305}
			y={300}
			labelWidth={120}
			width={80}
			// title='Глубина заложения от поверхности, м:'
			type = 'number'
			min={0}
			max={999}
			step={0.1}
			key={'horizontal' + elements.length}
			onChange={this[this.getChangeFromType('t')]}
			value={this.state[this.getFilterFromType('t')]}
			onBlur={this[this.getBlurFromType('t')]}
		/>)

		elements.push(<div
			key={'horizontal' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'304px',
				left:'440px',
				zIndex:'10',
			}}
		>Сечение, мм:</div>)

		elements.push(<DropDown
			x={535}
			y={300}
			labelWidth={120}
			width={80}
			// title='Сечение заземлителя, мм:'
			key={'horizontal' + elements.length}
			onChange={this[this.getChangeFromType('sg')]}
			value={this.state[this.getFilterFromType('sg')]}
			options={this.state[this.getOptionsFromType('sg')]}
		/>)

		elements.push(<div
			key={'horizontal' + elements.length}
			className={styles.smallText}
			style={{
				position: 'absolute',
				top:'298px',
				left:'670px',
				zIndex:'10',
				width:'180px'
			}}
		>Общая длина соеденительной полосы Lсоед, м:</div>)

		elements.push(<Input
			x={860}
			y={300}
			labelWidth={120}
			width={80}
			// title='Общая длина соед. полосы, м:'
			type = 'number'
			min={2}
			max={500}
			step={0.5}
			key={'horizontal' + elements.length}
			onChange={this[this.getChangeFromType('lCon')]}
			value={this.state[this.getFilterFromType('lCon')]}
			onBlur={this[this.getBlurFromType('lCon')]}
		/>)

		elements.push(<div key={'horizontal' + elements.length}>
		<span className={styles.lConInfo}
					onPointerEnter={() => this.setState({showAdditionlConInfo: true})}
					onPointerLeave={() => this.setState({showAdditionlConInfo: false})}>&#63;</span>
			{this.state.showAdditionlConInfo
				&& <span className={styles.showlCon}>
						Расстояние от контура до стены здания, умноженное на количество точек подсоединения к контуру</span>}
		</div>)



		return elements
	}

	infoInput(){
		let elements = [];

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={10}
			width={240}
			rows={2}
			title='Название объекта'
			onChange={this[this.getChangeFromType('name')]}
			disabled={false}
			value={this.state[this.getFilterFromType('name')]}
		/>)

		elements.push(<Input
			key={'info' + elements.length}
			x={20}
			y={90}
			width={240}
			title='Автор проекта'
			onChange={this[this.getChangeFromType('author')]}
			disabled={false}
			value={this.state[this.getFilterFromType('author')]}
		/>)

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={140}
			width={240}
			rows={2}
			title='Адрес объекта'
			onChange={this[this.getChangeFromType('address')]}
			disabled={false}
			value={this.state[this.getFilterFromType('address')]}
		/>)

		elements.push(<ImageInput
			key={'info' + elements.length}
			title={'Выберите изображение объекта (.jpg, .jpeg, .png)'}
			x={20}
			y={220}
			onChange={this[this.getChangeFromType('projectImg')]}
			onInput={this[this.getChangeFromType('projectImg')]}
		/>)

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={290}
			width={240}
			title='Описание'
			onChange={this[this.getChangeFromType('desc')]}
			disabled={false}
			value={this.state[this.getFilterFromType('desc')]}
		/>)

		elements.push(
			<div style={{
				top: '420px',
				width: '140px'
			}}
					 key={'info' + elements.length}
					 className={styles.selectBlank}
			/>
		)

		return elements
	}

	onNameChange(event){
		this.setState({filterName: event.target.value})
	}

	onAuthorChange(event){
		this.setState({filterAuthor: event.target.value})
	}

	onAddressChange(event){
		this.setState({filterAddress: event.target.value})
	}

	onDescChange(event){
		this.setState({filterDesc: event.target.value})
	}

	onProjectImgChange(event){
		const fReader = new FileReader();
		fReader.readAsDataURL(event.target.files[0]);
		fReader.onloadend = (e) =>{
			this.setState({
				filterProjectImg:e.target.result
			})
		}
	}


	// ++ Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="20"
				y="710"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сброс"
				onClick={this.onBtnClearClick}
				key="clear"
			/>
		);

		this.state.reportEnable && !this.state.loadReport ?
			elements.push(
				<PDFDownloadLink key={'pdf'} document={<PDFCountReport
					Rn={this.state.filterRn}
					climate={this.state.filterClimate}
					sg={this.state.filterSg}
					ratio={this.state.filterRatio}
					ro1={this.state.filterRo1}
					ro2={this.state.filterRo2}
					H={this.state.filterH}
					Lv={this.state.filterLv}
					Dv={this.state.filterDv}
					position={this.state.filterPosition}
					b={Number(this.state.filterSg.substr(0,2))}
					LCon={this.state.filterLCon}
					tline={this.state.filterT}
					t={this.state.t}
					kc1={this.state.kc1}
					kc2={this.state.kc2}
					ki1={this.state.ki1}
					ki2={this.state.ki2}
					pekv={this.state.pekv}
					roc={this.state.roc}
					rv={this.state.rv}
					rline={this.state.rline}
					lp={this.state.lp}
					lv={this.state.lv}
					n={this.state.n}
					r={this.state.r}
					npred={this.state.npred}
					name={this.state.filterName}
					address={this.state.filterAddress}
					desc={this.state.filterDesc}
					author={this.state.filterAuthor}
					imgData={this.state.filterProjectImg}
					date={new Date().toLocaleDateString()}
				/>} fileName="Отчет.pdf"
												 style={{
													 position: 'absolute',
													 top:'710px',
													 left:'250px',
												 }}>

					<div className={styles.mainBtn} title={'Сохранить отчет'}>
						{styles.pdfBtnIcon &&
							<div className={styles.pdfBtnIcon}></div>
						}
						<span className={styles.mainBtnText}>{'Сохранить отчет'}</span>
					</div>
				</PDFDownloadLink>
			)
			:
			elements.push(<Button
				x="250"
				y="710"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить отчет"
				onClick={this.onBtnSaveClick}
				key="emptyPdf"
			/>)

		elements.push(
			<Button
				x="480"
				y="710"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Главное меню"
				onClick={this.onNavConfigurator}
				key="backToNav"
			/>
		);


		elements.push(
			<Button
				x="1170"
				y="710"
				buttonStyle={styles.buttonDoc}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Нормативно-техническая документация"
				onClick={this.onDocConfigurator}
				key="doc"
			/>
		);

		return elements;
	}
	// -- Кнопки

// -- Рендре

// ++ Обработка событий

	// ++ Инпут
	onRnChange(event){
		this.setState({filterRn: event.target.value})
	}

	onRnBlur(event){
		let value = event.target.value
		if(value < 0) 	{
			this.setState({filterRn: 0})
			return
		}

		if(!Number.isInteger(value)) 	{
			value = Math.trunc(value)
		}

		this.setState({filterRn: value})
	}

	onRo1Change(event) {
		this.setState({filterRo1: event.target.value})
	}

	onRo1Blur(event){
		let value = event.target.value
		if(value < 0) {
			this.setState({filterRo1:0})
			return
		}
		if(!Number.isInteger(value)) 	{
			value = Math.trunc(value)
		}
		this.setState({filterRo1:value})
	}

	onRo2Change(event){
		this.setState({filterRo2: event.target.value})
	}

	onRo2Blur(event){
		let value = event.target.value
		if(value < 0) {
			this.setState({filterRo2: 0})
			return
		}
		if(!Number.isInteger(value)) 	{
			value = Math.trunc(value)
		}
		this.setState({filterRo2: value})
	}

	onHChange(event){
		this.setState({filterH: event.target.value})
	}

	onHBlur(event){
		let value = event.target.value
		if(value < 0) {
			this.setState({filterRo2: 0})
			return
		}
		this.setState({filterH: Number(value).toFixed(2)})
	}

	onLvChange(event){
		this.setState({filterLv: event.target.value})
	}

	onLvBlur(event){
		let value = event.target.value
		if(value < 3) {
			this.setState({filterLv: 3})
			return
		}
		this.setState({filterLv: value})
	}

	onRatioChange(event){
		this.setState({filterRatio: event.target.value})
	}

	onRatioBlur(event){
		let value = event.target.value
		if((value < 1) || (value > 3)) {
			this.setState({filterRatio: 3})
			return
		}
		this.setState({filterRatio: value})
	}

	onLConChange(event){
		this.setState({filterLCon: event.target.value})
	}

	onLConBlur(event){
		let value = event.target.value
		if((value < 2) || (value > 500)) {
			this.setState({filterLCon: 2})
			return
		}
		this.setState({filterLCon: value})
	}

	onTChange(event){
		this.setState({filterT: event.target.value})
	}

	onTBlur(event){
		let value = event.target.value
		if(value < 0.7) {
			this.setState({filterT: 0.7})
			return
		}
		this.setState({filterT: value})
	}

	// -- Инпут

	// ++ ДропДауны
	onClimateChange(event){
		this.setState({filterClimate: event.target.value})
	}
	onDvChange(event){
		this.setState({filterDv: event.target.value})
	}
	onPositionChange(event){
		this.setState({filterPosition: event.target.value})
	}
	onSgChange(event){
		this.setState({filterSg: event.target.value})
	}
	// -- ДропДауны

	// ++ Кнопки
	onBtnCountClick(){

		this.setState({
			loadReport:true,
		}, () => {
			setTimeout(() =>{
				this.setState({
					loadReport:false,
				})
			}, 1000)

			// деструктуризовать
			const {filterRn, filterClimate, filterRo1, filterRo2, filterH, filterDv, filterPosition,
				filterRatio = Math.round(filterRatio), filterSg, b = Number(filterSg.substr(0,2)), } = this.state

			const filterLv = Number(this.state.filterLv)
			const filterT = Number(this.state.filterT)
			const filterLCon = Number(this.state.filterLCon)
			const kc1 = ksTable.ks1[filterClimate] // Стержневой
			const kc2 = ksTable.ks2[filterClimate] // Полосовой

			let warning = ''

			if (!filterRn) warning = 'Значение нормируемого сопративления заземляющего устройства "Rn" не может быть равно 0. \n'
			if (!filterRo1) warning = warning + 'Удельное сопротивление верхнего слоя грунта "p1" не может быть равно 0. \n'
			if (!filterRo2) warning = warning + 'Удельное сопротивление нижнего слоя грунта "p2" не может быть равно 0. \n'
			if (!filterH) warning = warning + 'Толщина верхнего слоя грунта "Н" не может быть равно 0. \n'

			if(warning) {
				this.showWarning(warning)
				return
			}

			const pekv = ((filterRo1 * filterRo2 * filterLv) / (filterRo1 * (filterLv - filterH + filterT) + filterRo2 * (filterH - filterT))).toFixed(1)
			const t = ((filterLv / 2) + filterT).toFixed(1)
			const roc = (((kc1 *pekv) / (2 * Math.PI * filterLv))*(Math.log((2*filterLv*1000)/filterDv) + 0.5 * Math.log((4 * t + filterLv) / (4 * t - filterLv)))).toFixed(2)
			const npred = Math.ceil(roc / filterRn)
			const ki1 = this.getCoef(npred, ki1Table[filterPosition][filterRatio]) // Вертикальные заземлители
			const ki2 = this.getCoef(npred, ki2Table[filterPosition][filterRatio]) // Горзонтальные заземлители
			const lp = filterPosition === 'В ряд' ? (filterLv * (npred - 1) + filterLCon).toFixed(2) : (filterLv * npred + filterLCon).toFixed(1)
			const rline = (((kc2*pekv) / (2 * Math.PI * lp * ki2))*(Math.log((2*lp*lp)/(b*filterT*0.001)))).toFixed(2)
			const rv = ((rline * filterRn)/(rline - filterRn)).toFixed(2)
			const n = (roc/(rv*ki1)).toFixed()
			const r = (((rline/(ki1*n)) * roc)/((roc/(ki1*n))+Number(rline))).toFixed(2)
			const lv = filterPosition === 'В ряд' ? (filterLv * (n - 1) + filterLCon).toFixed(2) : (filterLv * n + filterLCon).toFixed(1)

			this.setState({
				pekv,
				roc,
				rv,
				rline,
				lp,
				lv,
				n,
				r,
				reportEnable:true,
				ki1,
				ki2,
				kc1,
				kc2,
				t,
				npred,
			})
		})

	}

	onBtnClearClick(){
		this.setState({
			...defaultState,
			...defaultResult
		})
	}

	onBtnSaveClick(){
		if(!this.state.reportEnable){
			this.showWarning('Перед формирование отчета рассчитайте параметры заземления')
		}
	}

	onNavConfigurator() {
		if (this.props.onNavConfigurator) {
			this.props.onNavConfigurator();
		}
	}

	onDocConfigurator() {
		if (this.props.onDocConfigurator) {
			this.props.onDocConfigurator();
		}
	}

	// -- Кнопки

// -- Обработка событий

	// Отрисовка
	render() {

		const resultRenderData = [
			{top:40, str:'Удельное расчетное сопротивление грунта, ρ экв, Ом×м:', result: this.state.pekv},
			{top:60, str:'Сопротивление одного вертикального заземлителя из круглой стали, Rос, Ом:', result: this.state.roc},
			{top:80, str:'Полное сопротивление растеканию тока вертикального заземлителя, Rверт, Ом:', result: this.state.rv},
			{top:100, str:'Сопротивление растеканию тока горизонтального заземлителя, Rполосы, Ом:', result: this.state.rline},
			{top:120, str:'Общее сопротивление заземляющего устройства R, Ом:', result:  this.state.r},
			{top:140, str:'Длина горизантального заземлителя (с учетом соединительной полосы), Lг, м:', result: this.state.lv},
			{top:160, str:'Количество вертикальных заземлителей, шт:', result: this.state.n},
		]

		return (
			<div className={styles.cfg}>

				{
					this.state.showWarn
						?
						<Popup
							warningText={this.state.warningText}
							onClick={this.clickAwayHandler}
						/>
						:
						null
				}

				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '10%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Оранжевый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#ffcc3f', width: '100%', height: '80px'}}>
					<div className={styles.title}>Расчет заземления</div>
				</div>
				{/*Левая Часть*/}
				<div style={{
					position: 'absolute',
					margin: '0 auto',
					backgroundColor: '#fff',
					width: '1040px',
					height: '345px',
					top:'100px',
					left:'340px'
				}}>
					<div className={styles.sectionTitle} style={{
						position: 'absolute',
						margin: '0 auto',
						top:'20px',
						textAlign: 'center',
						width: '1040px',
					}}>
						<span style ={{
							minWidth:'500px',
						}}>
							Исходные данные
						</span>
					</div>
					{this.getCountBlock && this.getCountBlock()}

				</div>

				{/*Правая Часть*/}
				<div>

					<div style={{
						position:'relative',
						left: '20px',
						top: '20px',
						width: '300px',
						height: '40px',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						backgroundColor: '#fff',
					}}>
						<div className={styles.sectionTitle}
								 style={{
									 position: 'absolute',
									 margin: '0 auto',
									 top:'20px',
									 textAlign: 'center',
									 width: '300px',
								 }}>
							<span style ={{
								minWidth:'300px',
							}}>
								Данные объекта
							</span>
						</div>
					</div>

					<div style={{
						position: 'absolute',
						margin: '0 auto',
						backgroundColor: '#fff',
						width: '300px',
						height: '340px',
						top:'140px',
						left:'20px',
						overflowY: 'scroll'
					}}>
						{this.infoInput ? this.infoInput() : null}
					</div>

				</div>

				<button
					style={{top: '461px', left: '800px'}}
					className={styles.countButton}
					onClick={this.onBtnCountClick}
				>Расчет</button>

				<div style={{
					position: 'absolute',
					margin: '0 auto',
					backgroundColor: '#fff',
					width: '1040px',
					height: '190px',
					top:'500px',
					left:'340px'
				}}>
					<div className={styles.sectionTitle} style={{
						position: 'absolute',
						margin: '0 auto',
						top:'15px',
						textAlign: 'center',
						width: '1040px',
					}}>
						<span style ={{
							minWidth:'300px',
						}}>
							Результаты
						</span>
					</div>
					{ this.state.loadReport
						?
							<div>
								<svg className={styles.preloader__image} role="img" xmlns="http://www.w3.org/2000/svg"
										 viewBox="0 0 512 512">
									<path fill="currentColor"
												d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z">
									</path>
								</svg>
							</div>
						: resultRenderData.map(item =>{
							return this.getResultStr({
								...item
							})
						})
					}
				</div>

				<Image
					className={styles.scheme}
					blockChangeScale={false}
				/>

				{/*Кнопки*/}
				{this.getCustomButtons ? this.getCustomButtons() : null}

				{/*Нижняя плашка*/}
				{/* На основной сайт IEK */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '760px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>
				<span className={styles.feedBack}>Почта для связи: kiselevav@iek.ru</span>
				<div style={{
					position: 'absolute',
					top: '765px',
					left: '1350px',
					zIndex: '15'
				}}>
					<GroundLightVersion />
				</div>
				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffcc3f',
					width: '50%',
					height: '20px',
					top: '760px',
					left: '700px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '763px',
					left: '415px',
					color: '#3c4e50',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>

			</div>
		)
	}

}



export default GroundCalculationConfigurator;



// WEBPACK FOOTER //
// ./src/react/GroundCalculationConfigurator.jsx